import { render, staticRenderFns } from "./HouseDetails.vue?vue&type=template&id=0b2ff628&"
import script from "./HouseDetails.vue?vue&type=script&lang=js&"
export * from "./HouseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports